var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ 'overflow': _vm.$route.name === 'live' ? 'hidden' : '' }),attrs:{"id":"app"}},[_c('bar'),_c('keep-alive',{attrs:{"include":['recommend']}},[_c('router-view')],1),_c('tab-bar'),_c('global-loading'),_c('global-popup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }